import React, { CSSProperties } from "react"
import { MobergButton, MobergButtonShape } from "../MobergButton/MobergButton"
import { MobergFontFamily } from "../MobergFont/MobergFont"
import { getColors, MobergTheme } from "../MobergThemes/MobergColors"

type MobergMenuItemProps = {
    disabled?: boolean
    tooltip?: string
    onClick: (event: any) => void
    icon?: React.ReactNode
    theme?: MobergTheme
    style?: CSSProperties
}

export const MobergMenuItem: React.FC<MobergMenuItemProps> = ({ children, disabled, tooltip, onClick, icon, theme, style }) => {
    const themeColor = theme ? getColors(theme).main : undefined

    return (
        <MobergButton shape={MobergButtonShape.FULL_WIDTH} onClick={onClick} disabled={disabled} tooltip={tooltip}
            style={{
                justifyContent: "start",
                padding: "2px 8px",
                paddingRight: "16px",
                borderRadius: 0,
                gap: "16px",
                fontFamily: MobergFontFamily.REGULAR,
                fontWeight: "inherit",
                color: themeColor,
                ...style
            }}>
            {children}
            {icon && <span style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>{icon}</span>}
        </MobergButton>
    )
}
